import type { ReactNode } from 'react'
import Tooltip from '@mui/material/Tooltip'
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon'
import {
  Chat as SlackIcon,
  GitHub as GitHubIcon,
  Inventory2Outlined as EmptyRepoIcon,
  Webhook as WebhooksIcon,
} from '@mui/icons-material'
import type { OrgIntegrationSubPage } from '../../utils/organizationSettingsNav'

/** Brand paths from Simple Icons (CC0). Origin has no separate mark — use the Cursor cube. */

export function OriginIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path d="M11.503.131 1.891 5.678a.84.84 0 0 0-.42.726v11.188c0 .3.162.575.42.724l9.609 5.55a1 1 0 0 0 .998 0l9.61-5.55a.84.84 0 0 0 .42-.724V6.404a.84.84 0 0 0-.42-.726L12.497.131a1.01 1.01 0 0 0-.996 0M2.657 6.338h18.55c.263 0 .43.287.297.515L12.23 22.918c-.062.107-.229.064-.229-.06V12.335a.59.59 0 0 0-.295-.51l-9.11-5.257c-.109-.063-.064-.23.061-.23" />
    </SvgIcon>
  )
}

export function GiteaIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path d="M4.209 4.603c-.247 0-.525.02-.84.088-.333.07-1.28.283-2.054 1.027C-.403 7.25.035 9.685.089 10.052c.065.446.263 1.687 1.21 2.768 1.749 2.141 5.513 2.092 5.513 2.092s.462 1.103 1.168 2.119c.955 1.263 1.936 2.248 2.89 2.367 2.406 0 7.212-.004 7.212-.004s.458.004 1.08-.394c.535-.324 1.013-.893 1.013-.893s.492-.527 1.18-1.73c.21-.37.385-.729.538-1.068 0 0 2.107-4.471 2.107-8.823-.042-1.318-.367-1.55-.443-1.627-.156-.156-.366-.153-.366-.153s-4.475.252-6.792.306c-.508.011-1.012.023-1.512.027v4.474l-.634-.301c0-1.39-.004-4.17-.004-4.17-1.107.016-3.405-.084-3.405-.084s-5.399-.27-5.987-.324c-.187-.011-.401-.032-.648-.032zm.354 1.832h.111s.271 2.269.6 3.597C5.549 11.147 6.22 13 6.22 13s-.996-.119-1.641-.348c-.99-.324-1.409-.714-1.409-.714s-.73-.511-1.096-1.52C1.444 8.73 2.021 7.7 2.021 7.7s.32-.859 1.47-1.145c.395-.106.863-.12 1.072-.12zm8.33 2.554c.26.003.509.127.509.127l.868.422-.529 1.075a.686.686 0 0 0-.614.359.685.685 0 0 0 .072.756l-.939 1.924a.69.69 0 0 0-.66.527.687.687 0 0 0 .347.763.686.686 0 0 0 .867-.206.688.688 0 0 0-.069-.882l.916-1.874a.667.667 0 0 0 .237-.02.657.657 0 0 0 .271-.137 8.826 8.826 0 0 1 1.016.512.761.761 0 0 1 .286.282c.073.21-.073.569-.073.569-.087.29-.702 1.55-.702 1.55a.692.692 0 0 0-.676.477.681.681 0 1 0 1.157-.252c.073-.141.141-.282.214-.431.19-.397.515-1.16.515-1.16.035-.066.218-.394.103-.814-.095-.435-.48-.638-.48-.638-.467-.301-1.116-.58-1.116-.58s0-.156-.042-.27a.688.688 0 0 0-.148-.241l.516-1.062 2.89 1.401s.48.218.583.619c.073.282-.019.534-.069.657-.24.587-2.1 4.317-2.1 4.317s-.232.554-.748.588a1.065 1.065 0 0 1-.393-.045l-.202-.08-4.31-2.1s-.417-.218-.49-.596c-.083-.31.104-.691.104-.691l2.073-4.272s.183-.37.466-.497a.855.855 0 0 1 .35-.077z" />
    </SvgIcon>
  )
}

export function GitLabIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path d="m23.6004 9.5927-.0337-.0862L20.3.9814a.851.851 0 0 0-.3362-.405.8748.8748 0 0 0-.9997.0539.8748.8748 0 0 0-.29.4399l-2.2055 6.748H7.5375l-2.2057-6.748a.8573.8573 0 0 0-.29-.4412.8748.8748 0 0 0-.9997-.0537.8585.8585 0 0 0-.3362.4049L.4332 9.5015l-.0325.0862a6.0657 6.0657 0 0 0 2.0119 7.0105l.0113.0087.03.0213 4.976 3.7264 2.462 1.8633 1.4995 1.1321a1.0085 1.0085 0 0 0 1.2197 0l1.4995-1.1321 2.4619-1.8633 5.006-3.7489.0125-.01a6.0682 6.0682 0 0 0 2.0094-7.003z" />
    </SvgIcon>
  )
}

export function BitbucketIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path d="M.778 1.213a.768.768 0 00-.768.892l3.263 19.81c.084.5.515.868 1.022.873H19.95a.772.772 0 00.77-.646l3.27-20.03a.768.768 0 00-.768-.891zM14.52 15.53H9.522L8.17 8.466h7.561z" />
    </SvgIcon>
  )
}

export type GitProviderName = 'github' | 'origin' | 'gitea' | 'gitlab' | 'bitbucket'

export function normalizeGitProvider(provider?: string | null): GitProviderName {
  const key = (provider ?? '').trim().toLowerCase()
  if (key === 'origin' || key === 'gitea' || key === 'gitlab' || key === 'bitbucket') {
    return key
  }
  return 'github'
}

export function gitProviderLabel(provider?: string | null): string {
  switch (normalizeGitProvider(provider)) {
    case 'origin':
      return 'Origin'
    case 'gitea':
      return 'Gitea'
    case 'gitlab':
      return 'GitLab'
    case 'bitbucket':
      return 'Bitbucket'
    default:
      return 'GitHub'
  }
}

export function ForgeSourceIcon({
  provider,
  fontSize = 18,
  inheritColor = false,
  tooltip = true,
  connected = true,
}: {
  provider?: string | null
  fontSize?: number
  /** When true, inherit color from the parent (sidebar active/hover). */
  inheritColor?: boolean
  tooltip?: boolean
  /** False when the project has no linked repositories — do not default to GitHub. */
  connected?: boolean
}) {
  const sx: SvgIconProps['sx'] = {
    fontSize,
    color: inheritColor ? 'inherit' : connected ? 'text.primary' : 'text.secondary',
  }
  if (!connected) {
    const empty = <EmptyRepoIcon sx={sx} />
    if (!tooltip) return empty
    return (
      <Tooltip title="No repository connected">
        <span style={{ display: 'inline-flex', lineHeight: 0 }}>{empty}</span>
      </Tooltip>
    )
  }
  const key = normalizeGitProvider(provider)
  const icon =
    key === 'origin' ? (
      <OriginIcon sx={sx} />
    ) : key === 'gitea' ? (
      <GiteaIcon sx={sx} />
    ) : key === 'gitlab' ? (
      <GitLabIcon sx={sx} />
    ) : key === 'bitbucket' ? (
      <BitbucketIcon sx={sx} />
    ) : (
      <GitHubIcon sx={sx} />
    )
  if (!tooltip) return icon
  return (
    <Tooltip title={gitProviderLabel(key)}>
      <span style={{ display: 'inline-flex', lineHeight: 0 }}>{icon}</span>
    </Tooltip>
  )
}

export function integrationSubIcon(sub: OrgIntegrationSubPage): ReactNode {
  switch (sub) {
    case 'slack':
      return <SlackIcon />
    case 'webhooks':
      return <WebhooksIcon />
    case 'github':
      return <GitHubIcon />
    case 'origin':
      return <OriginIcon />
    case 'gitea':
      return <GiteaIcon />
    case 'gitlab':
      return <GitLabIcon />
    case 'bitbucket':
      return <BitbucketIcon />
  }
}
